export default __webpack_public_path__ + "images/5C.835b03e.png";